import React from "react";
import ValidationError from "../ValidationError";

interface Props {
  class: string;
  errorMessage: string;
  inputId: string;
  inputStep: string;
  inputValue: string | number | readonly string[];
  isHidden: boolean;
  isInvalid: boolean;
  placeholder: boolean;
  placeholderText?: string;
  letterSpacing?: boolean;
  maxLength: number;
  inputRef: React.LegacyRef<HTMLInputElement>;
  type: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  onInput?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown? :  (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const NumericInput = (props: Props) => {
  return (
    <>
      <input
        id={props.inputId}
        ref={props.inputRef}
        type={props.isHidden ? "password" : props.type}
        className={`${props.class}-input p-2 ${props.isInvalid ? 'input-error' : ''} ${props.letterSpacing ? "numeric-letter-spacing" : ""}`}
        placeholder={props.placeholderText}
        step={props.inputStep}
        inputMode="numeric"
        maxLength={props.maxLength}
        value={props.inputValue}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        onInput={props.onInput}
        onKeyDown={props.onKeyDown}
      />
      <ValidationError
        isInvalid={props.isInvalid}
        message={props.errorMessage as string}
        placeholder={props.placeholder}
      />
    </>
  );
}

NumericInput.defaultProps = {
  class: "text",
  errorMessage: "",
  inputStep: "1",
  isInvalid: false,
  placeholder:true,
  letterSpacing: false,
  placeholderText: "",
  isHidden: false,
  maxLength: 20,
  inputRef: undefined,
  type: "text",
  onChange: undefined,
  onBlur: undefined,
  onFocus: undefined
}

export default NumericInput;
